import { useState, useEffect } from "react";
import { TrashIcon, PlusIcon } from "@heroicons/react/24/solid";

export default function Sidebar({ areas, onAreaChange, addArea, removeArea }) {
  const areasList = areas
    .sort((a, b) => a.name.localeCompare(b.name))
    .map((area) => (
      <AreaEditor
        key={area.name}
        area={area}
        onAreaChange={onAreaChange}
        removeArea={removeArea}
      />
    ));

  return (
    <div className="drawer-side">
      <label
        htmlFor="my-drawer"
        aria-label="close sidebar"
        className="drawer-overlay"
      ></label>
      <div className="menu bg-base-200 text-base-content min-h-full w-80 p-4">
        <h1 className="text-2xl">Settings</h1>
        <div className="divider"></div>
        <ul>{areasList}</ul>
        <div className="divider"></div>
        <AreaCreator addArea={addArea} />
      </div>
    </div>
  );
}

function AreaEditor({ area, onAreaChange, removeArea }) {
  const [isEnabled, setIsEnabled] = useState(area.enabled);

  useEffect(() => {
    setIsEnabled(area.enabled);
  }, [area.enabled]);

  return (
    <li className="AreaEditor form-control">
      <label className="label flex cursor-pointer flex-row">
        <span className="label-text flex-1">{area.name}</span>
        <input
          type="checkbox"
          className="toggle toggle-primary"
          checked={isEnabled}
          onChange={() => {
            onAreaChange(area.name, { enabled: !isEnabled });
          }}
        />
        <button onClick={() => removeArea(area.name)}>
          <TrashIcon className="text-neutral h-6 w-6" />
        </button>
      </label>
    </li>
  );
}

function AreaCreator({ addArea }) {
  const [inputValue, setInputValue] = useState("");

  const addItem = () => {
    addArea({
      name: inputValue,
      enabled: true,
      rating: 0,
    });
    setInputValue("");
  };

  const onChange = ({ target: { value } }) => {
    setInputValue(value);
  };

  return (
    <div className="AreaCreator form-control">
      <div className="mb-2 flex flex-row">
        <PlusIcon className="mr-1 h-8 w-8" />
        <div className="flex items-center">
          <h2 className="text-lg">Create new</h2>
        </div>
      </div>
      <input
        type="text"
        className="input mb-2 w-full max-w-xs"
        value={inputValue}
        onChange={onChange}
      />
      <button className="btn btn-primary" onClick={addItem}>
        Save
      </button>
    </div>
  );
}
